var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { share } from 'rxjs/operators/share';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { zip } from 'rxjs/observable/zip';
import { addSeconds, differenceInSeconds, format, isValid } from 'date-fns';
import { SessionStorage, SessionStorageService } from '../jng2-webstorage/app';
import { ApplicationService } from '../application/application.service';
import { ConfigService } from '../config/config.service';
import { SplashService } from '../splash/splash.service';
import { UserService } from '../user/user.service';
import { VERSION_NUMBER, BUILD_TIME } from '../version/version.service';
import { DialogService } from '../dialogs/dialogs.service';
var AuthService = /** @class */ (function () {
    function AuthService(http, appService, configService, userService, router, sessionStorage, dialogService, splashService) {
        var _this = this;
        this.http = http;
        this.appService = appService;
        this.configService = configService;
        this.userService = userService;
        this.router = router;
        this.sessionStorage = sessionStorage;
        this.dialogService = dialogService;
        this.splashService = splashService;
        this._subRelease = new Subject();
        this.systemOnline = false;
        this.HasVersionUpdate = new Subject();
        this.SystemOnlineSubject = new Subject();
        this.BuildTime = new Subject();
        this.VersionNumber = new Subject();
        this.AuthRefreshDeadline = this.nextAuthRefresh ? new Date(this.nextAuthRefresh) : null;
        this.IsRefreshing = false;
        var bmoment = new Date(BUILD_TIME);
        if (isValid(bmoment)) {
            this.BuildTime.next(format(bmoment, 'MMM. DD, YYYY h:mm t'));
        }
        this.VersionNumber.next(VERSION_NUMBER);
        this.SystemOnlineSubject.next({
            SystemMessage: '',
            Status: this.systemOnline,
            DeltaVersion: VERSION_NUMBER,
        });
        // Set up the subscription to watch for the user being updated, so we can tell if we need to boot up auth token refreshing.
        this.userService.UserSubject.pipe(share(), takeUntil(this._subRelease)).subscribe(function (user) {
            // See if we have a User object already known to us. If so, this was a refresh of the page most likely,
            // and thus we need to kick start authtoken refreshing again.
            if (user && !_this.IsRefreshing && user.AuthToken) {
                _this.StartAuthTokenRefreshing();
            }
        });
    }
    AuthService.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    // #region Add New User Service Call
    AuthService.prototype.AddNewUser = function (AuthToken, CurrentRole, FirstName, LastName, Email, CollegeID, Role) {
        return this.http.post(this.configService.hostAddress + "Api/Services/Authentication/AddNewUser", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
            Email: Email || '',
            CollegeID: CollegeID || '',
            Role: Role || '',
        });
    };
    // #endregion
    // #region Add New User As Designee Service Call
    AuthService.prototype.AddNewUserAsDesignee = function (AuthToken, CurrentRole, UserID, FirstName, LastName, Email, SchoolNumber, RoleID, CanBypassAdmin) {
        return this.http.post(this.configService.hostAddress + "Api/Services/Authentication/AddNewUserAsDesignee", {
            AuthToken: AuthToken || '',
            CurrentRole: CurrentRole || '',
            UserID: UserID || '',
            FirstName: FirstName || '',
            LastName: LastName || '',
            Email: Email || '',
            SchoolNumber: SchoolNumber || '',
            RoleID: RoleID || '',
            CanBypassAdmin: CanBypassAdmin || '',
        });
    };
    // #endregion
    // #region Auth Token Refresh Method
    AuthService.prototype.AuthTokenRefresh = function () {
        var _this = this;
        var self = this;
        // Now retrieve the auth token for the currently logged in user, stored in the userService
        var auth = this.userService.User.AuthToken;
        // Send a request to the system to check to see if the user's "Recent Use" flag is set. If it is, we will refresh their
        // auth token and reset all countdown timers.
        this.CheckRecentUse(auth).subscribe(function (recentUse) {
            // If we get a non-null result, it indicates the status of the "Recent Use" flag. If it's true, we trigger an
            // auth token refresh, which in turn will reset the clock for our next check of recent use, etc.
            if (recentUse === true) {
                // Call the service which will refresh the auth token.
                _this.RefreshAuthToken(auth).subscribe(function (newAuthPacket) {
                    var newAuth = (newAuthPacket && newAuthPacket.AuthToken) || newAuthPacket;
                    if (newAuthPacket && newAuthPacket.DeltaVersion) {
                        // We have version information. Does it match the version known here in the TypeScript?
                        // If not, set the update flag.
                        if (VERSION_NUMBER !== newAuthPacket.DeltaVersion) {
                            // Mismatch. Set the flag.
                            _this.HasVersionUpdate.next(true);
                        }
                    }
                    // We have a valid, new auth token. Update the User variable in the userService to reflect this.
                    _this.userService.UpdateAuthToken(newAuth);
                    // If there is no flag signal set preventing this loop from continuing, then we can set up the
                    // next iteration with a timeout now.
                    if (!_this.AuthTokenCancelFlag) {
                        _this.AuthTokenRefreshHandle = window.setTimeout(function () {
                            _this.AuthTokenRefresh();
                        }, AuthService.AUTHCHECKTIME * 1000);
                        // Set the refresh deadline app value
                        var Now = new Date();
                        _this.AuthRefreshDeadline = addSeconds(Now, AuthService.AUTHCHECKTIME);
                        _this.nextAuthRefresh = _this.AuthRefreshDeadline.toISOString();
                    }
                }, function (error) {
                    // An error occurred. Attempt to retrieve it.
                    var body = error.json();
                    body =
                        (body && body.Message) ||
                            body ||
                            'An error occurred while trying to valid your active connection to the system. You have been logged out.';
                    _this.splashService.SnackbarError(body, 5000);
                });
            }
            else {
                // We either could not retrieve the "Recent Use" flag, or we DID and it was false. In either case, we must begin a
                // countdown process to log out the user from the system.
                // First, disable the current auth token refresh cycling. We won't restart that until we get feedback from the user.
                _this.CancelAuthTokenRefreshing();
                var options = {
                    TitleText: 'Session Inactivity Logout',
                    MessageText: "You are about to be automatically logged out of the system due to inactivity. If you wish to " +
                        "stay logged in to the site, please click the \"Stay Logged In\" button below.",
                    OKText: 'Stay Logged In',
                    CancelText: 'Log Out',
                    CountdownTime: AuthService.LOGOUTWARNINGTIME,
                };
                _this.dialogService.OpenCountdownDialog(options).subscribe(function (res) {
                    if (res === true) {
                        // User wants to stay logged in - Restart the auth token refresh cycling.
                        _this.RefreshAuthToken(auth).subscribe(function (newAuthPacket) {
                            var newAuth = (newAuthPacket && newAuthPacket.AuthToken) || newAuthPacket;
                            if (newAuthPacket && newAuthPacket.DeltaVersion) {
                                // We have version information. Does it match the version known here in the TypeScript?
                                // If not, set the update flag.
                                if (VERSION_NUMBER !== newAuthPacket.DeltaVersion) {
                                    // Mismatch. Set the flag.
                                    _this.HasVersionUpdate.next(true);
                                }
                            }
                            // We have a new valid auth token to use. Update the user object accordingly with the new token.
                            _this.userService.UpdateAuthToken(newAuth);
                            // If there is no flag signal set preventing this loop from continuing, then we can set up the
                            // next iteration with a timeout now.
                            if (!_this.AuthTokenCancelFlag) {
                                _this.AuthTokenRefreshHandle = window.setTimeout(function () {
                                    _this.AuthTokenRefresh();
                                }, AuthService.AUTHCHECKTIME * 1000);
                                // Set the refresh deadline app value
                                var Now = new Date();
                                _this.AuthRefreshDeadline = addSeconds(Now, AuthService.AUTHCHECKTIME);
                                _this.nextAuthRefresh = _this.AuthRefreshDeadline.toISOString();
                            }
                        }, function (error) {
                            // Snackbar the error
                            var body = error.json();
                            body =
                                (body && body.Message) ||
                                    body ||
                                    "An error occurred while trying to valid your active connection to the system. " +
                                        "You have been logged out.";
                            _this.splashService.SnackbarError(body, 5000);
                        });
                    }
                    else {
                        // User wishes to logout, or the timer expired. Either way, log them out.
                        _this.Logout(false, 1);
                    }
                });
            }
        }, function (error) {
            // This represents an error when trying to get recent use. Likely this is due to the session expiring in the
            // authtoken. In this case, cancel the refresh handle, and log out the user.
            _this.CancelAuthTokenRefreshing();
            _this.Logout(false, 2);
        });
    };
    // #endregion
    // #region Cancel Auth Token Refreshing Method
    AuthService.prototype.CancelAuthTokenRefreshing = function () {
        // If possible, use the handle to cancel the timeout from happening
        if (this.AuthTokenRefreshHandle != null) {
            window.clearTimeout(this.AuthTokenRefreshHandle);
        }
        // Cancel the flag, handle, and deadline to refresh
        this.AuthTokenRefreshHandle = null;
        this.AuthTokenCancelFlag = null;
        this.AuthRefreshDeadline = null;
        this.IsRefreshing = false;
        this.nextAuthRefresh = null;
    };
    // #endregion
    // #region Check Recent Use Service Method - This method simply calls the database to see if the user has done anything
    AuthService.prototype.CheckRecentUse = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/Authentication/CheckRecentUse?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Classlink SSO Login Service Call
    AuthService.prototype.ClasslinkSSOLogin = function (token, screen, winres) {
        return this.http.post(this.configService.hostAddress + 'Api/Services/Authentication/ClasslinkSSOLogin', {
            Token: token,
            Screen: screen,
            Window: winres,
        });
    };
    // #endregion
    // #region Create New Account Service Call
    AuthService.prototype.CreateNewAccount = function (firstName, lastName, password, email) {
        return this.http.post(this.configService.hostAddress + 'Api/Services/Authentication/CreateNewAccount', {
            FirstName: firstName,
            LastName: lastName,
            Password: password,
            Email: email,
        });
    };
    // #endregion
    // #region Handle Service Error Service Call
    AuthService.prototype.HandleServiceError = function (error) {
        var self = this;
        var status = null;
        var msg = null;
        if (error instanceof HttpResponse) {
            status = error.status;
            var body = error.body;
            msg = body.Message || (typeof body === 'string' ? body : 'An unknown error has occurred.');
        }
        else if (error instanceof HttpErrorResponse) {
            status = error.status;
            msg = error.error || error.message || error;
        }
        else {
            var errorPacket = error.message || error;
            if (errorPacket != null && errorPacket !== '' && errorPacket[0] === '{') {
                errorPacket = JSON.parse(errorPacket);
            }
            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';
        }
        if (status === 408) {
            // This is a Request Timeout response, indicating the user's session has expired.
            self.dialogService
                .OpenMessageBoxDialog({
                TitleText: 'Session Timed Out',
                MessageText: "Your current session to the DELTA System has timed out and your login access has been " +
                    "closed. In order to continue using the DELTA System you will need to login again to the system.",
            })
                .subscribe(function (res) {
                // Force an unconfirmed logout to clear user stored values and return to the login screen.
                self.Logout(false, 2);
            });
        }
        else {
            // Something else, which should be snackbar displayed.
            self.splashService.SnackbarError(msg, 8000);
        }
    };
    // #endregion
    // #region Logout Service Call
    AuthService.prototype.Logout = function (confirmation, reason) {
        var _this = this;
        if (confirmation === true) {
            // Pop up a confirmation box to confirm desire to logout.
            var opts = {
                TitleText: 'Confirmation Requested',
                MessageText: 'You are about to log out of the site. Are you sure you wish to exit at this time?',
                OKText: 'Yes - Log Out',
                CancelText: 'No - Stay Logged In',
            };
            this.dialogService.OpenConfirmationDialog(opts).subscribe(function (result) {
                if (result === true) {
                    // User is opting to log out. Proceed.
                    _this.http
                        .get(_this.configService.hostAddress +
                        ("Api/Services/Authentication/Logout?AuthToken=" + _this.userService.User.AuthToken + "&Reason=" + reason))
                        .subscribe();
                    // Stop authtoken refreshing
                    _this.CancelAuthTokenRefreshing();
                    // Null out the current user.
                    _this.userService.ClearUser();
                    // Snackbar the logout if this was user initiated (reason null or 0)
                    if (reason == null || reason === 0) {
                        _this.splashService.SnackbarSuccess('Successfully logged out.', 500000);
                    }
                    // Close out all remaining open dialogs
                    _this.dialogService.CloseAllDialogs();
                    // Navigate to the login state.
                    _this.router.navigate(['/login']);
                }
            });
        }
        else {
            // No dialog needed. Exit out.
            this.http
                .get(this.configService.hostAddress +
                ("Api/Services/Authentication/Logout?AuthToken=" + (this.userService.User.AuthToken || '') + "&Reason=" + reason))
                .subscribe(function (result) { });
            // Stop authtoken refreshing
            this.CancelAuthTokenRefreshing();
            // Null out the current user.
            this.userService.ClearUser();
            // Snackbar the logout if this was user initiated (reason null or 0)
            if (reason == null || reason === 0) {
                this.splashService.SnackbarSuccess('Successfully logged out.', 5000);
            }
            // Close out all remaining open dialogs
            this.dialogService.CloseAllDialogs();
            // Navigate to the login state.
            this.router.navigate(['/login']);
        }
    };
    // #endregion
    // #region Focus SSO Login Service Call
    AuthService.prototype.FocusSSOLogin = function (source, packet, screen, winres) {
        return this.http.post(this.configService.hostAddress + 'Api/Services/Authentication/FocusSSOLogin', {
            Source: source,
            Packet: packet,
            Screen: screen,
            Window: winres,
        });
    };
    // #endregion
    // #region Process Login Service Method
    AuthService.prototype.ProcessLogin = function (user) {
        var _this = this;
        var self = this;
        // Set the currently logged in user information.
        self.userService.SetUser(user);
        // Load all remaining application wide information that requires AuthToken to load
        // Retrieve the list of known colleges for use in the system.
        var collegesObs = self.appService.GetAllColleges(user.AuthToken);
        // Retrieve the list of known district schools for use in the system.
        var schoolsObs = self.appService.GetAllSchools(user.AuthToken);
        // Retrieve the list of available dual enrollment programs.
        var depgmsObs = self.appService.GetDualEnrollmentPrograms(user.AuthToken);
        // Retrieve the list of available accelerated degree programs.
        var accpgmsObs = self.appService.GetAcceleratedDegreePrograms(user.AuthToken);
        zip(collegesObs, schoolsObs, depgmsObs, accpgmsObs, function (colleges, schools, dePrograms, accPrograms) {
            return {
                Colleges: colleges,
                Schools: schools,
                DEPrograms: dePrograms,
                AccPrograms: accPrograms,
            };
        })
            .pipe(takeUntil(self._subRelease))
            .subscribe(function (packet) { }, function (error) {
            self.HandleServiceError(error);
        });
        // Route to the proper home component for the user. Prefer in this order: developer, district, parent, student (not yet implemented)
        if (user.Roles) {
            if (user.Roles.IsDeveloper) {
                // Set the current role
                this.userService.SetUserCurrentRole('Developer');
            }
            else if (user.Roles.IsDistrictAdmin) {
                this.userService.SetUserCurrentRole('DistrictAdmin');
            }
            else if (user.Roles.IsDistrictUser) {
                this.userService.SetUserCurrentRole('DistrictUser');
            }
            else if (user.Roles.IsCollegeAdmin) {
                // For college admins, did we receive advisor college info? If not, then we cannot proceed.
                if (!user.StaffColleges || !user.StaffColleges.length) {
                    // Alert the user, and gracefully exit out.
                    this.dialogService
                        .OpenMessageBoxDialog({
                        TitleText: 'No College Advising/Administration Configured',
                        MessageText: "There appear to be no colleges currently configured for your DELTA access. " +
                            "The DELTA system is only available for college administrators who have a college registered to " +
                            "them. If this is an error, please contact the Polk County Public Schools DELTA contact for " +
                            "further assistance.",
                    })
                        .subscribe(function (res) {
                        // Logout the user.
                        _this.Logout(false, 2);
                    });
                    return;
                }
                this.userService.SetUserCurrentRole('CollegeAdmin');
            }
            else if (user.Roles.IsAdvisor) {
                // For advisors, did we receive advisor college info? If not, then we cannot proceed.
                if (!user.StaffColleges || !user.StaffColleges.length) {
                    // Alert the user, and gracefully exit out.
                    this.dialogService
                        .OpenMessageBoxDialog({
                        TitleText: 'No College Advising Configured',
                        MessageText: "There appear to be no colleges currently configured for your DELTA access. The " +
                            "DELTA system is only available for advisors who have a college registered to them. If this " +
                            "is an error, please contact the DELTA college administrator at your college for further assistance.",
                    })
                        .subscribe(function (res) {
                        // Logout the user.
                        _this.Logout(false, 2);
                    });
                    return;
                }
                this.userService.SetUserCurrentRole('Advisor');
            }
            else if (user.Roles.IsCollegeSupport) {
                // For support staff, did we receive college info? If not, then we cannot proceed.
                if (!user.StaffColleges || !user.StaffColleges.length) {
                    // Alert the user, and gracefully exit out.
                    this.dialogService
                        .OpenMessageBoxDialog({
                        TitleText: 'No Colleges Configured',
                        MessageText: "There appear to be no colleges currently configured for your DELTA access. The " +
                            "DELTA system is only available for support staff who have a college registered to them. If this " +
                            "is an error, please contact the DELTA college administrator at your college for further assistance.",
                    })
                        .subscribe(function (res) {
                        // Logout the user.
                        _this.Logout(false, 2);
                    });
                    return;
                }
                this.userService.SetUserCurrentRole('CollegeSupport');
            }
            else if (user.Roles.IsSchoolAdmin) {
                this.userService.SetUserCurrentRole('SchoolAdmin');
            }
            else if (user.Roles.IsCounselor) {
                this.userService.SetUserCurrentRole('Counselor');
            }
            else if (user.Roles.IsStudent) {
                this.userService.SetUserCurrentRole('Student');
            }
            else if (user.Roles.IsParent) {
                this.userService.SetUserCurrentRole('Parent');
            }
            else {
                // No matching role - no access.
                this.dialogService
                    .OpenMessageBoxDialog({
                    TitleText: 'Alert - No Access Rights Detected',
                    MessageText: "You do not currently have access rights to the Dual Enrollment Link to Advisors " +
                        "(DELTA) system. Access is currently only available to middle-school and high-school students, " +
                        "parents, school counselors and administrators, select district staff, and college advisors. We " +
                        "apologize for the inconvenience.",
                })
                    .subscribe(function (res) {
                    // Logout the user.
                    _this.Logout(false, 2);
                });
            }
        }
    };
    // #endregion
    // #region Refresh Authentication Token Service Method
    AuthService.prototype.RefreshAuthToken = function (AuthToken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/Authentication/RefreshAuthToken?AuthToken=" + (AuthToken || '')));
    };
    // #endregion
    // #region Reset User Password Service Call
    AuthService.prototype.ResetUserPassword = function (password, valtoken) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/Authentication/ResetUserPassword?Password=" + password + "&ValToken=" + valtoken));
    };
    // #endregion
    // #region Send Password Reset Request Email Service Call
    AuthService.prototype.SendPasswordResetRequestEmail = function (email) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/Authentication/SendPasswordResetRequestEmail?EmailAddress=" + email));
    };
    // #endregion
    // #region Send Username Request Email Service Call
    AuthService.prototype.SendUsernameRequestEmail = function (email) {
        return this.http.get(this.configService.hostAddress + ("Api/Services/Authentication/SendUsernameRequestEmail?EmailAddress=" + email));
    };
    // #endregion
    // #region Set System Online Status
    AuthService.prototype.SetSystemOnlineStatus = function (status) {
        this.systemOnline = (status && status.Status) || false;
        this.SystemOnlineSubject.next(status);
    };
    // #endregion
    // #region Start AuthToken Refreshing Service Call
    AuthService.prototype.StartAuthTokenRefreshing = function () {
        // Check to see what time we are next due to refresh at (if we can find that info in the session storage).
        // If we find that time, reset the date to track that, and fire up auth refreshing. Otherwise, we trigger an
        // immediate auth refresh just in case.
        var _this = this;
        // Temporarily disable any pending cancellation of the auth token refresh cycle.
        this.AuthTokenCancelFlag = false;
        // Check real quick for a present value for nextAuthRefresh. If that exists, then it indicates the time
        // when we absolutely need to refresh the auth token, so we should set the refresh handle time to that time.
        // Otherwise, we aim for an immediate (1 second from now) refresh.
        var timeToRefresh = AuthService.AUTHCHECKTIME;
        if (this.nextAuthRefresh) {
            // Read the deadline time to refresh from the session storage, convert into a Date object.
            this.AuthRefreshDeadline = new Date(this.nextAuthRefresh);
        }
        else {
            // Nothing available from session storage, so queue up a fresh refresh clock.
            this.AuthRefreshDeadline = addSeconds(new Date(), AuthService.AUTHCHECKTIME);
        }
        if (this.AuthRefreshDeadline && isValid(this.AuthRefreshDeadline)) {
            // Find the time difference in seconds between now and when we are due to refresh.
            var timediff = differenceInSeconds(this.AuthRefreshDeadline, new Date());
            // We will always use the lesser of the next known time to refresh and the usual delay time.
            // This is in case we are refreshing the browser and need to restart refresh cycle, as opposed to fresh starting cycles.
            if (timediff < timeToRefresh) {
                timeToRefresh = timediff;
            }
            if (timeToRefresh <= 0) {
                timeToRefresh = 1;
            } // Ensure at least a 1 second wait.
        }
        this.AuthTokenRefreshHandle = window.setTimeout(function () {
            _this.AuthTokenRefresh();
        }, timeToRefresh * 1000);
        // Set the refresh deadline app value
        var Now = new Date();
        this.AuthRefreshDeadline = addSeconds(Now, timeToRefresh);
        this.IsRefreshing = true;
        this.nextAuthRefresh = this.AuthRefreshDeadline.toISOString();
    };
    // #endregion
    // #region Test Connection Service Call
    AuthService.prototype.TestConnection = function () {
        // Call the WebApi to see if anyone is home.
        return this.http.get(this.configService.hostAddress + 'Api/Services/Authentication/TestConnection');
    };
    // #endregion
    // #region Timeout Login Service Call
    AuthService.prototype.TimeoutLogin = function (password) {
        var self = this;
        var user = self.userService.User;
        var validateObs = null;
        return Observable.create(function (tempObs) {
            // Disable auth refreshing, since that token is useless now anyway.
            self.CancelAuthTokenRefreshing();
            // Is the current user session an impersonated one? If so, the password provided must be used with the username provided.
            if (user.IsImpersonation === true) {
                // Attempt to validate the user again using the known username of the impersonator, the password provided,
                // and the username of the impersonated session.
                validateObs = self.ValidateTimeoutImpersonationLogin(user.ImpersonatorUsername, password, user.AccountName, window.screen.width + 'x' + window.screen.height, window.innerWidth + 'x' + window.innerHeight);
            }
            else {
                // Validate the user again using the current account name, password provided, and so forth. This is essentially
                // a brand new login without a page redirect on logging in.
                validateObs = self.ValidateUser(user.AccountName, password, null, window.screen.width + 'x' + window.screen.height, window.innerWidth + 'x' + window.innerHeight);
            }
            // No matter which way, subscribe to result to trigger it.
            validateObs.pipe(takeUntil(self._subRelease)).subscribe(function (info) {
                // Set the currently logged in user information. This will update the authtoken.
                self.userService.SetUser(info);
                // Restart auth refreshing now that we have a valid authtoken to work with.
                self.StartAuthTokenRefreshing();
                // Trigger the containing observer so the caller is aware we've finished our work.
                tempObs.next(true);
                tempObs.complete();
            }, function (error) {
                self.HandleServiceError(error);
            });
        });
    };
    // #endregion
    // #region Validate Timeout Impersonation Login Service Call
    AuthService.prototype.ValidateTimeoutImpersonationLogin = function (impersonatorUsername, password, impersonatedUsername, screen, winres) {
        return this.http
            .post(this.configService.hostAddress + 'Api/Services/Authentication/ValidateTimeoutImpersonationLogin', {
            Username: impersonatorUsername || '',
            Password: password || '',
            ImpersonatedUsername: impersonatedUsername || '',
            Screen: screen || '',
            Window: winres || '',
        })
            .pipe(map(function (res) {
            var body = res;
            if (body && body.Roles) {
                body.IsAdvisor = body.Roles.IsAdvisor;
                body.IsCollegeAdmin = body.Roles.IsCollegeAdmin;
                body.IsCollegeSupport = body.Roles.IsCollegeSupport;
                body.IsCounselor = body.Roles.IsCounselor;
                body.IsDeveloper = body.Roles.IsDeveloper;
                body.IsDistrictAdmin = body.Roles.IsDistrictAdmin;
                body.IsDistrictUser = body.Roles.IsDistrictUser;
                body.IsSchoolAdmin = body.Roles.IsSchoolAdmin;
                body.IsStudent = body.Roles.IsStudent;
                body.IsMultiRole = body.Roles.IsMultiRole;
            }
            return body;
        }));
    };
    // #endregion
    // #region Validate User Service Call
    AuthService.prototype.ValidateUser = function (username, password, impersonatedUsername, screen, winres) {
        return this.http
            .post(this.configService.hostAddress + 'Api/Services/Authentication/ValidateUser', {
            Username: username || '',
            Password: password || '',
            ImpersonatedUsername: impersonatedUsername || '',
            Screen: screen || '',
            Window: winres || '',
        })
            .pipe(map(function (res) {
            var body = res;
            if (body && body.Roles) {
                body.IsAdvisor = body.Roles.IsAdvisor;
                body.IsCollegeAdmin = body.Roles.IsCollegeAdmin;
                body.IsCollegeSupport = body.Roles.IsCollegeSupport;
                body.IsCounselor = body.Roles.IsCounselor;
                body.IsDeveloper = body.Roles.IsDeveloper;
                body.IsDistrictAdmin = body.Roles.IsDistrictAdmin;
                body.IsDistrictUser = body.Roles.IsDistrictUser;
                body.IsSchoolAdmin = body.Roles.IsSchoolAdmin;
                body.IsStudent = body.Roles.IsStudent;
                body.IsMultiRole = body.Roles.IsMultiRole;
            }
            return body;
        }));
    };
    // 10 minutes (time period to wait between successive checks of whether the auth token is recently used)
    AuthService.AUTHCHECKTIME = 10 * 60;
    // 2 minutes, 50 seconds (time period to wait before logging the user out automatically). Roughly 20 minutes total between check
    // and autologout
    AuthService.LOGOUTWARNINGTIME = 170;
    __decorate([
        SessionStorage(),
        __metadata("design:type", String)
    ], AuthService.prototype, "nextAuthRefresh", void 0);
    __decorate([
        SessionStorage(),
        __metadata("design:type", Object)
    ], AuthService.prototype, "systemOnline", void 0);
    return AuthService;
}());
export { AuthService };
var AuthPacket = /** @class */ (function () {
    function AuthPacket() {
    }
    return AuthPacket;
}());
export { AuthPacket };
var TestConnectionPacket = /** @class */ (function () {
    function TestConnectionPacket() {
    }
    return TestConnectionPacket;
}());
export { TestConnectionPacket };



// WEBPACK FOOTER //
// ./src/services/authentication/auth.service.ts.pre-build-optimizer.js